// How far the account's running sync has got, shown inside a card's
// "not ready" banner so a first sync reads as progress rather than as broken.
//
// The expected time is the backend's straight-line estimate from the pace so
// far, labelled as an estimate; before any report lands there is no pace to go
// on and none is shown.
import React from 'react';

const formatIst = (iso) => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return `${date.toLocaleString('en-IN', {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
    timeZone: 'Asia/Kolkata',
  })} IST`;
};

const SyncProgress = ({ progress }) => {
  if (!progress) return null;
  const expected = progress.expected_by && formatIst(progress.expected_by);
  return (
    <div>
      Your Amazon sync is running: {progress.reports_done} of {progress.reports_total} reports
      {' '}have landed.
      {expected ? ` Expected to finish around ${expected} (estimate).` : ''}
    </div>
  );
};

export default SyncProgress;
